import React from 'react';
import theme from './ResidentialExpandedListItem.module.scss';

interface BuyerContactInfoProps {
    email: string;
    phoneNumber: string;
}

const BuyerContactInfo: React.FC<BuyerContactInfoProps> = ({ email, phoneNumber }) => {
    return (
        <div className={theme.contactInfo}>
            <a href={`mailto:${email}`} className={theme.contactLink}>
                {email}
            </a>
            <a href={`tel:${phoneNumber}`} className={theme.contactLink}>
                {phoneNumber}
            </a>
        </div>
    );
};

export default BuyerContactInfo; 